export default "__VITE_ASSET__mRRY$fY9__"